import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { isSupportedPrefix } from '../config/languages.js';
import NotFound from '../pages/NotFound.js';

// Guards the `/:lang` route segment: renders the nested routes only
// when `lang` is a recognized language prefix, otherwise 404s.
// Actual i18n language activation happens in <LanguageSync />, not here.
const LangGate = () => {
  const { lang } = useParams();

  if (!isSupportedPrefix(lang)) {
    return <NotFound />;
  }

  return <Outlet />;
};

export default LangGate;
